import React, { Fragment } from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function QuoteStepHeader({
  steps,
  currentStep,
  onChangeStep
}) {
  return <div className="mb-8" data-id="element-5110" data-mp="14hvu1xq456rj">
      <div className="flex items-center justify-center" data-id="element-5111" data-mp="qp68fuehy3uy">
        {steps.map((step, index) => <Fragment key={index} data-id="element-5112" data-mp="qncwbzl46rfk" data-mpi={index}>
            <div className={`relative flex flex-col items-center group ${index <= currentStep ? 'cursor-pointer' : 'cursor-not-allowed'}`} onClick={() => index <= currentStep && onChangeStep(index)} data-id="element-5113" data-mp="vnr4dhmpu1dl">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${index < currentStep ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-md' : index === currentStep ? 'bg-white text-indigo-900 shadow-md' : 'bg-slate-700/50 text-slate-400'}`} data-id="element-5114" data-mp="1nfqagwtkmkjy">
                {step.icon || index + 1}
              </div>
              <div className={`absolute -bottom-6 whitespace-nowrap text-xs font-medium ${index <= currentStep ? 'text-indigo-200' : 'text-slate-500'}`} data-id="element-5115" data-mp="3u4le6jfudraa">
                {step.label}
              </div>
            </div>
            {index < steps.length - 1 && <div className={`w-16 h-1 mx-1 ${index < currentStep ? 'bg-gradient-to-r from-indigo-500 to-purple-600' : 'bg-slate-700/50'}`} data-id="element-5116" data-mp="ljniqr04dh7d"></div>}
          </Fragment>)}
      </div>
      <div className="h-6" data-id="element-5117" data-mp="ujtt440iu12b"></div>
    </div>;
}